import api from "../api";

export const useMakeWithdrawRequest = (data) => {

  return api
    .post(`/withdraw`, data)
    .then((res) => res.data);
  
};
